export const MENU_LANGUAGE_CODES = ['es', 'en', 'pt', 'fr', 'it', 'zh', 'ar', 'de'] as const;

export type MenuLanguageCode = typeof MENU_LANGUAGE_CODES[number];
export type MenuLanguagePreferenceSource = 'manual' | 'profile' | 'browser' | 'fallback';

export interface MenuLanguagePreference {
  preferredLanguage: MenuLanguageCode;
  preferenceSource: MenuLanguagePreferenceSource;
}

export function resolveMenuLanguage(languageType?: number | string | null): MenuLanguageCode {
  // El selector de idioma es un <select> HTML: sus "value" siempre llegan como string
  // (ej. "2"), por eso se normaliza aquí antes de comparar con los códigos numéricos.
  const normalized = typeof languageType === 'string' ? parseInt(languageType, 10) : languageType;
  switch (normalized) {
    case 2: return 'en';
    case 3: return 'pt';
    case 4: return 'fr';
    case 5: return 'it';
    case 6: return 'zh';
    case 7: return 'ar';
    case 8: return 'de';
    default: return 'es';
  }
}

export function menuLanguageId(language: MenuLanguageCode): number {
  return MENU_LANGUAGE_CODES.indexOf(language) + 1;
}

export function normalizeMenuLanguage(language?: string | null): MenuLanguageCode {
  const primaryCode = (language || '').trim().toLowerCase().split(/[-_]/)[0];
  return MENU_LANGUAGE_CODES.includes(primaryCode as MenuLanguageCode)
    ? primaryCode as MenuLanguageCode
    : 'es';
}

// Respuesta del endpoint público GET /api/v2/cartas/{idCarta}/language/{idioma}.
// available=false significa "traducción aún no creada", NO un error HTTP.
export interface MenuLanguageResolution {
  idCarta: number | null;
  idCatalogo: number | null;
  idioma: string;
  available: boolean;
}
